import * as React from "react";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import YouTubeIcon from "@material-ui/icons/YouTube";
import InstagramIcon from "@material-ui/icons/Instagram";
import styled from "styled-components";
import Theme from "../Theme";

const IconLink = styled.a`
  padding: 3px;

  & svg {
    fill: ${Theme.colors.blackText};
  }

  &:hover svg {
    fill: ${Theme.colors.greyText};
  }

  &:hover #Rectangle-path {
    fill: ${Theme.colors.greyText};
  }
`;

export default () => {
  return (
    <>
      <IconLink href="https://www.facebook.com/Skyward.Inc/">
        <FacebookIcon />
      </IconLink>
      <IconLink href="https://twitter.com/skyward_inc">
        <TwitterIcon />
      </IconLink>
      <IconLink href="https://www.linkedin.com/company/skyward">
        <LinkedInIcon />
      </IconLink>
      <IconLink href="https://www.youtube.com/skywardk12">
        <YouTubeIcon />
      </IconLink>
      <IconLink href="https://www.instagram.com/skyward_inc/">
        <InstagramIcon />
      </IconLink>
    </>
  );
};
